import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { alpha } from "@mui/material/styles";

export default function EditModeClearAllButton({ onClear }) {
  return (
    <Button
      onClick={onClear}
      fullWidth
      variant="outlined"
      sx={{
        mt: 1,
        borderRadius: "10px",
        textTransform: "none",
        fontWeight: 600,
        fontSize: "0.8rem",
        color: "secondary.main",
        borderColor: "grey.300",
        backgroundColor: "background.paper",
        "&:hover": {
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.06),
          borderColor: "primary.main",
        },
      }}
    >
      Quitar parametros
    </Button>
  );
}

EditModeClearAllButton.propTypes = {
  onClear: PropTypes.func.isRequired,
};
